var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.625 4C9.625 3.51675 10.0168 3.125 10.5 3.125H10.675C11.1582 3.125 11.55 3.51675 11.55 4C11.55 4.48325 11.1582 4.875 10.675 4.875H10.5C10.0168 4.875 9.625 4.48325 9.625 4ZM9.625 11C9.625 10.5168 10.0168 10.125 10.5 10.125H10.675C11.1582 10.125 11.55 10.5168 11.55 11C11.55 11.4832 11.1582 11.875 10.675 11.875H10.5C10.0168 11.875 9.625 11.4832 9.625 11ZM9.625 18C9.625 17.5168 10.0168 17.125 10.5 17.125H10.675C11.1582 17.125 11.55 17.5168 11.55 18C11.55 18.4832 11.1582 18.875 10.675 18.875H10.5C10.0168 18.875 9.625 18.4832 9.625 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMore);
export default __webpack_public_path__ + "static/media/icn_more.81fc8c113d0e4ea495792678ff9d5521.svg";
export { ForwardRef as ReactComponent };